import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  SUBSCRIBE_TAG: `${cleanedFilename(__filename)}-subscribe-tag`,
};
